import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_CODE_TYPES_LOOKUPS = "GET_CODE_TYPES_LOOKUPS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetCodeTypesLookup?eaAuditId=` +(data.eaAuditId??0),
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_CODE_TYPES_LOOKUPS, service, mock);
